import request from '@/utils/request'

// 获取论坛开关状态
export function getForumConfig() {
  return request({
    url: '/api/common/forum-config',
    method: 'get'
  })
}

// 获取论坛首页数据
export function getForumHome(params) {
  return request({
    url: '/api/forum/home',
    method: 'get',
    params
  })
}

// 获取分区帖子列表
export function getBoardPosts(params) {
  return request({
    url: '/api/forum/posts',
    method: 'get',
    params
  })
}

// 获取帖子详情
export function getPostDetail(id) {
  return request({
    url: '/api/forum/post/' + id,
    method: 'get'
  })
}

// 发帖
export function createPost(data) {
  return request({
    url: '/api/forum/post',
    method: 'post',
    data
  })
}

// 编辑帖子
export function updatePost(id, data) {
  return request({
    url: '/api/forum/post/' + id,
    method: 'put',
    data
  })
}

// 删帖
export function deletePost(id) {
  return request({
    url: '/api/forum/post/' + id,
    method: 'delete'
  })
}

// 置顶/取消
export function togglePin(id) {
  return request({
    url: '/api/forum/post/' + id + '/pin',
    method: 'put'
  })
}

// 加精/取消
export function toggleEssence(id) {
  return request({
    url: '/api/forum/post/' + id + '/essence',
    method: 'put'
  })
}

// 发表评论
export function addComment(data) {
  return request({
    url: '/api/forum/comment',
    method: 'post',
    data
  })
}

// 删评论
export function deleteComment(id) {
  return request({
    url: '/api/forum/comment/' + id,
    method: 'delete'
  })
}

// 点赞/取消
export function toggleLike(data) {
  return request({
    url: '/api/forum/like',
    method: 'post',
    data
  })
}

// 收藏/取消
export function toggleFavorite(data) {
  return request({
    url: '/api/forum/favorite',
    method: 'post',
    data
  })
}

// 我的收藏
export function getMyFavorites(params) {
  return request({
    url: '/api/forum/my-favorites',
    method: 'get',
    params
  })
}

// 上传帖子图片
export function uploadPostImage(formData) {
  return request({
    url: '/api/forum/upload-image',
    method: 'post',
    data: formData
  })
}

// 编辑坛规
export function updateBoardRule(id, data) {
  return request({
    url: '/api/forum/board/' + id + '/rule',
    method: 'put',
    data
  })
}